export function getAttributeByKey(attributes = []) {
  return key => attributes.find(attribute => attribute.key === key)?.value
}
